import { render, staticRenderFns } from "./RegisterBuyPackage.vue?vue&type=template&id=46f2165f&scoped=true"
import script from "./RegisterBuyPackage.vue?vue&type=script&lang=js"
export * from "./RegisterBuyPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f2165f",
  null
  
)

export default component.exports